import { type UTPlacesSetWorkPlanOrigin } from "@outlook/unified_telemetry";

export default function getPlacesSetWorkPlanOrigin(entryPoint: "PlacesNativeApp" | "CalendarPeekView" | "MyDayPane"): UTPlacesSetWorkPlanOrigin {
    switch (entryPoint) {
        case "PlacesNativeApp":
            return "PlacesNativeApp";
        case "CalendarPeekView":
            return "CalendarPeekView";
        case "MyDayPane":
            return "MyDayPane";
    }
}
